//
// Generic API request function.
//
export const request = (url, options = {}, token = null) => {
  if (token) {
    options.headers = {
      ...options.headers,
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  return fetch(url, options)
    .then(response => {
      return response.ok
        ? response.status === 204 ? {} : response.json()
        : Promise.reject({
            status: response.status,
            text: response.statusText
          });
    });
};

//
// GET
//
export const get = (url, token = null) => {
  const options = { method: 'GET' };
  return request(url, options, token);
};

//
// POST
//
export const post = (url, data, token = null) => {
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' }
  };

  return request(url, options, token);
};

//
// POST (form)
//
export const submit = (url, data, token = null) => {
  const options = {
    method: 'POST',
    body: data
  };

  return request(url, options, token);
};

//
// PUT
//
export const put = (url, data, token = null) => {
  const options = {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' }
  };

  return request(url, options, token);
};

//
// DELETE
//
export const del = (url, token = null) => {
  const options = { method: 'DELETE' };
  return request(url, options, token);
};



// WEBPACK FOOTER //
// ./src/api/client.js